import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import background from "../../assets/img/shopping_background.jpg";
import applicationLogo from "../../assets/img/logos/dicelogo.png";
import Login from "../../components/authAdmin/Login";
import Register01 from "../../components/authAdmin/Register01";
import Register02 from "../../components/authAdmin/Register02";
import Register02b from "../../components/authAdmin/Register02b";
import Forgotpassword01 from "../../components/authAdmin/Forgotpassword01";
import Forgotpassword02 from "../../components/authAdmin/Forgotpassword02";
import Forgotpassword02b from "../../components/authAdmin/Forgotpassword02b";

const Masterauthwebpage = (props) => {
  let tagName;

  switch (props.name) {
    case "Login":
      tagName = <Login />;
      break;
    case "Register01":
      tagName = <Register01 />;
      break;
    case "Register02":
      tagName = <Register02 />;
      break;
    case "Register02b":
      tagName = <Register02b />;
      break;
    case "Forgotpassword01":
      tagName = <Forgotpassword01 />;
      break;
    case "Forgotpassword02":
      tagName = <Forgotpassword02 />;
      break;
    case "Forgotpassword02b":
      tagName = <Forgotpassword02b />;
      break;
    default:
      tagName = <Login />;
  }

  return (
    <>
      <div
        className="bg-silver-300 py-5"
        style={{
          backgroundImage: `url(${background})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center top",
          height: "93vh",
        }}
      >
        <div className="content">
          <div className="brand">
            <Link to="/">
              <img
                loading="lazy"
                decoding="async"
                src={applicationLogo}
                alt={applicationLogo || "Image"}
                width={"80%"}
              />
            </Link>
          </div>
          <form
            id="login-form"
            action="#"
            method="post"
            className="mb-5"
            style={{ opacity: "0.9" }}
          >
            {tagName}
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Masterauthwebpage;
